import React from 'react';
import axios from 'axios';
import urlBase from '../../../url-base';
import { Col, Container, Row } from 'reactstrap';
import Paper from '@material-ui/core/Paper';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';


//import Barr from '../../../components/charts/BarChart';
import {Doughnut, HorizontalBar, Line} from 'react-chartjs-2';

const availWidth = window.screen.availWidth;


class Select extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            anoSelecionado: new Date().getFullYear(),
            chartPropostaSituacao:[],
            chartPropostaCanceladas:[],
            chartVendasMensais:[],
            dadosAnoAnterior:[],
            dadosAnoAtual:[],
            chartPlanosVendidos : [],
            anos:[],
          
        };
        this.options = {
            chart: {
              title: 'Aderência de volume',
              subtitle: 'Mês, volume: 2020',
            }
          };
        this.defaultProps = {
            displayTitle:true,
            displayLegend: false,
            legendPosition:'right',
            location:'Situação'
        },
        this.styles = {
      
            barChart : {
                height: "100%",
                paddingTop: 10,
                backgroundColor: "#fff",
                paddingLeft: 20
              },
                containerIcon: {
                paddingTop: 0,
                paddingBottom: 0
            },
            containerText: {
                paddingLeft: 0,
                height: 85,
            },
            containerTextDownload: {
                textAlign: 'center'
            },
            iconOrange: {
                backgroundColor: 'rgba(245, 170, 0, 0.72)',
                height: 85,
                textAlign: 'center',
                paddingTop: 12
            },
            iconRed: {
                backgroundColor: 'rgba(209, 4, 36, 0.62)',
                height: 85,
                textAlign: 'center',
                paddingTop: 25
            },
            iconBlue: {
                backgroundColor: 'rgba(2, 17, 199, 0.48)',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconGreen: {
                backgroundColor: 'rgba(5, 134, 15, 0.58)',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconDarkCyan: {
                backgroundColor: 'rgba(0,139,139,0.67)',
                height: 85,
                textAlign: 'center',
                paddingTop: 23
            },
            iconDimGray: {
                backgroundColor: 'rgba(105,105,105, 0.58)',
                height: 85,
                textAlign: 'center',
                paddingTop: 12
            },
            iconPurple: {
                backgroundColor: '#b778c7',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconBlueMega: {
                backgroundColor: '#809AE0',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconGreenCarta: {
                backgroundColor: '#63D88B',
                height: 85,
                textAlign: 'center',
                paddingTop: 14
            },
            h1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 17,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },
            hr: {
                height: '1px',
                backgroundColor: '#d1d1d1',
                textAlign: 'center',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '40px',
            },
            hh1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 2,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },
            h1Download: {
                width: 'auto',
                paddingLeft: 10,
                paddingRight: 10,
                fontSize: 14,
                fontWeight: 100,
            },
            paper: {
                width: 'auto',
                marginLeft: 20,
                marginRight: 20,

            },
            backgroundPaper: {
                backgroundColor: "#ffffff",
                height: 85,
            },


            p: {
                marginTop: 5,
                paddingTop: 13,
                fontSize: 14,
                fontWeight: 300,
                // width: 50,
                // height: 50,
                marginRight: 20,
                // backgroundColor: "#f9f9f9",
                borderRadius: "100%",
                textAlign: "center",
                fontFamily: 'RubikMedium',
                color: "#757575",
            },
            tituloPagina2: {
                fontSize: availWidth < 500 ? 18 : 23,
                fontFamily: 'RubikMedium',
                width: '100%',
                color: "#757575",
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingTop: 20,
                paddingBottom: 5,
                textAlign: "center",
            },
        };
  
    }


   componentWillMount(){
       this.getChartPropostaSituacao();
       this.getChartPropostaCanceladas();
       this.getChartVendasMensais();
       this.getChartPlanosVendidos();
       this.getAnos();
   }

   /**
    * Obtem os anos existentes para vendas
    */
   getAnos() {
    axios.get(urlBase.loopBack + 'Sales/Anos')
    .then((response) => {
        
        let state = this.state;
        state.anos = response.data.map(item => item.ano );
        console.log(state.anos);
        this.setState(state);

    })
    .catch(function (error) {
        alert("Erro ao buscar anos: "+ error.code);
    });         

   }   
   /**
    * Busca os dados e monta o gráfio de quantidade de propostas por situação
    */
   getChartPropostaSituacao() {
     //   let url = urlBase.loopBack + 'Inclusions/situationProposal?ano='+ this.state.anoSelecionado;
        let url = urlBase.loopBack + 'Sales/vendasPorSituacao?ano='+ this.state.anoSelecionado;

        axios.get(url)
        .then((response) => {
           // let labels = response.data.map(item => item.status.substring(item.status.lastIndexOf(" ")+1) );
           let labels = response.data.map(item => item.status );
            let dados = response.data.map(item => item.total );  
            if (labels == '') {
                labels = ['ATIVO', 'VALIDAÇÃO', 'PEDENTE','CANCELADO']
            }
            this.setState({
                chartPropostaSituacao:{
                 labels: labels,
                  datasets:[
                    {
                      label:'',
                      data: dados,
                      backgroundColor:[
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)'

                     //   'rgba(255, 99, 132, 0.6)',
                    //    'rgba(54, 162, 235, 0.6)',
                      //  'rgba(255, 206, 86, 0.6)',
                     //   'rgba(75, 192, 192, 0.6)'
             
                      ]
                    }
                  ]
                }
              });

        })
        .catch(function (error) {
            alert("Erro ao buscar dados estatísticos das propostas por situação: "+ error.code);
        });     

    }
    
    /**
    * Gera gráfico de vendas por tipo de plano 
    */
     getChartPlanosVendidos() {
        var randomColorGenerator = function () { 
            return '#' + (Math.random().toString(16) + '0000000').slice(2, 8); 
        };
        let url = urlBase.loopBack + 'Sales/planosVendidosPorAno?ano='+ this.state.anoSelecionado;
        axios.get(url)
        .then((response) => {
            let labels = response.data.map(item => item.plano);
            let dados = response.data.map(item => item.total );  

            let cores = [];
            let somaTotal = 0; 
            let percentual = [];

            for (var y=0; y < dados.length; y++) {
                cores.push(randomColorGenerator());
                somaTotal = somaTotal + dados[y];              
            }
            for (var i=0; i < dados.length; i++) {
                let valor = ((dados[i]*100)/somaTotal).toFixed(2);
                percentual.push( valor );
                labels[i] = labels[i] + ' (' +valor + '%)';

            }
            this.setState({
                chartPlanosVendidos:{
                 labels: labels,
                  datasets:[
                    {
                      label:'',
                      data: dados,
                      backgroundColor: cores,
/*                       backgroundColor:[
                        'rgba(255, 99, 132, 0.6)',
                        'rgba(54, 162, 235, 0.6)',
                        'rgba(255, 206, 86, 0.6)',
                        'rgba(75, 192, 192, 0.6)'
             
                      ]  */
                    }
                  ]
                }
              });

        })
        .catch(function (error) {
            alert("Erro ao buscar dados estatísticos das propostas canceladas: "+ error.code);
        });     

    }
    /**
    * Busca os dados e monta o gráfico de quantidade de propostas canceladas por tipo situação
    * REFAZER O BACK
    */
   getChartPropostaCanceladas() {
        let url = urlBase.loopBack + 'Inclusions/estatisticaCancelamentoProposal?ano='+ this.state.anoSelecionado;

        axios.get(url)
        .then((response) => {

            let labels = response.data.map(item => item.motivo);
            let dados = response.data.map(item => item.Total );  


            this.setState({
                chartPropostaCanceladas:{
                 labels: labels,
                  datasets:[
                    {
                      label:'',
                      data: dados,
                      backgroundColor:[
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)',
                        'rgba(80, 200, 120, 0.6)'
                        /*'rgba(255, 99, 132, 0.6)',
                        'rgba(54, 162, 235, 0.6)',
                        'rgba(255, 206, 86, 0.6)',
                        'rgba(75, 192, 192, 0.6)' */
             
                      ]
                    }
                  ]
                }
              });

        })
        .catch(function (error) {
            alert("Erro ao buscar dados estatísticos das propostas canceladas: "+ error.code);
        });     

    }
    /**
     * ANALIZAR MÉTODO PARA EXCLUIR - NÃO ESTÁ SENDO USADO
     */
    obterDadosVendasMensais() {
        let urlAnoAtual = urlBase.loopBack + 'FinancialManager/quantidadeVendasMensais?ano='+ this.state.anoSelecionado;
        let dadosAnoAtual = [];  

        axios.get(urlAnoAtual)
        .then((response) => {
            let meses = response.data.map(item => item.mes );
            dadosAnoAtual = response.data.map(item => item.total );  
            alert("Dados "+ dadosAnoAtual);
            for (var y=1; y < meses.length+1; y++) {

                    if ( meses.indexOf(y) == -1 ) {
                        dadosAnoAtual.splice(y-1, 0, 0);
                    }                
            }
            let states = this.state;
            states.dadosAnoAtual = dadosAnoAtual;
            this.setState(states); 
     
        })
        .catch(function (error) {
            alert("Erro ao buscar dados estatísco das vendas mensais: "+ error.code);
        });      

    }
    /**
    * Busca os dados e monta o gráfico de quantidade de propostas canceladas por tipo situação
    */
     getChartVendasMensais() {
        let labels = ['JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV','DEZ'];

        let urlAnoAtual = urlBase.loopBack + 'Sales/quantidadeVendasMensais?ano='+ this.state.anoSelecionado;
        let dadosAnoAtual = [];  

        axios.get(urlAnoAtual)
        .then((response) => {
            let meses = response.data.map(item => item.mes );
            dadosAnoAtual = response.data.map(item => item.total );  
            for (var y=1; y < meses.length+1; y++) {

                    if ( meses.indexOf(y) == -1 ) {
                        dadosAnoAtual.splice(y-1, 0, 0);
                    }                
            }
            let urlAnoAnterior = urlBase.loopBack + 'Sales/quantidadeVendasMensais?ano='+ (this.state.anoSelecionado-1);
            let dadosAnoAnterior = []; 
            axios.get(urlAnoAnterior)
            .then((responseAno) => {

                let mesesAnterior = responseAno.data.map(item => item.mes );
                dadosAnoAnterior = responseAno.data.map(item => item.total );  

                for (var y=1; y < mesesAnterior.length+1; y++) {
    
                        if ( mesesAnterior.indexOf(y) == -1 ) {
                            dadosAnoAnterior.splice(y-1, 0, 0);
                        }                
                }
                this.setState({
                    chartVendasMensais:{
                     labels: labels,
                      datasets:[
                        {
                            label: this.state.anoSelecionado,
                            data: dadosAnoAtual,
                            fill: true,
                            backgroundColor: "rgba(75,192,192,0.2)",
                            borderColor: "rgba(75,192,192,1)"
                          },
                          {
                            label: this.state.anoSelecionado-1,
                            data: dadosAnoAnterior,
                            fill: false,
                            borderColor: "#742774"
                          }
                      ]
                    }
                  });
            })
            .catch(function (error) {
                alert("Erro ao buscar dados estatísco do ano anterior: "+ error.code);
            });
     
        })
        .catch(function (error) {
            alert("Erro ao buscar dados estatísco do ano corrente: "+ error.code);
        }); 
   
    }    
    confirmationForm (e, value) {   
        let state = this.state;
        state.anoSelecionado = value;
        this.setState(state);
        this.getChartPropostaSituacao();
        this.getChartPropostaCanceladas();
        this.getChartVendasMensais();
        this.getChartPlanosVendidos();

      }
   
    render() {

        return (
            <div id="resume_content">
                <style>{`
          #resume_content a {
            color: inherit;
          }
          #resume_content a:hover {
            text-decoration: none;
          }
        `}</style>


        <div className='marginItens'>
                    <div style={this.styles.tituloPagina2}> DASHBOARD - ADMINISTRATIVO </div>
                    
                    <Container className="form_container_panel2">
                        <Container className="form_container_internal_panel">
                            
                        <Row>
                            <Col md="8">
                            </Col>
                            <Col md="4">
                                <RadioButtonGroup style={{ display: 'flex' }}
                                name="ano"
                                defaultValue="2021"
                                onChange={this.confirmationForm.bind(this)}
                                valueSelected={this.state.anoSelecionado}
                                >
 { 
                              this.state.anos.map((item) =>
                              <RadioButton
                              value={parseInt(item)}
                              label={item}
                              />
                              )}
{/*                                  <RadioButton
                                    value={2021}
                                    label="2021"
                                />
                                <RadioButton
                                    value={2022}
                                    label="2022"
                                        />  */}
                                </RadioButtonGroup>                        
                            </Col>
                        </Row>
                            
                        </Container>                        
                    </Container>                      
                    </div>

                    <Container className="form_container_panel2">
                        <Container className="form_container_internal_panel">
                                <Row>
                                <Col md="6" >
                                    <Paper> 
                                    {Object.keys(this.state.chartPlanosVendidos).length &&
                                    <Doughnut
                                        data={this.state.chartPlanosVendidos}
                                        options={{
                                        responsive: true,
                                        title:{
                                            display: true,
                                            text:'Planos vendidos por ano',
                                            fontSize:14
           
                                            },

                                        maintainAspectRatio: true,
                                        legend:{
                                            display:true,
                                            position:this.defaultProps.legendPosition
                                           }
                                               
                                        }}
                                    />                                      
                                    }
                                         </Paper>
                                    </Col>    
                                    <Col md="6" >
                                    <Paper> 
                                         <Line 
                                           data={this.state.chartVendasMensais}
                                           options={{
                                            title:{
                                            display: true,
                                            text:'Vendas Mensais',
                                            fontSize:14,
                           
                                                legend:{
                                                display:this.defaultProps.displayLegend,
                                                position:this.defaultProps.legendPosition
                                                }
                                            }

                                        }}                                           
                                        />                                        
                                   
                                         </Paper>
                                    </Col>                                                                    
                                </Row>   
                                <Row>
                                    <Col>
                                    <br></br>
                                    </Col>
                                </Row>                                                          
                                <Row>
                                    <Col md="6" >
                                    <Paper> 
                                    {Object.keys(this.state.chartPropostaSituacao).length &&
                                            <HorizontalBar
                                            data={this.state.chartPropostaSituacao}
                                            ref = {(reference) => this.reference = reference}
                                            options={{
                                                title:{
                                                display: true,
                                                text:'Propostas',
                                                fontSize:14
                                                },
                                                scales: {
                                                yAxes: [{
                                                    ticks: {
                                                    beginAtZero:true,
                                                    //max: this.props.max,
                                                    min: 0,
                                                    stepSize: 50
                                                    }
                                                }]
                                                },            
                                                legend:{
                                                 display:this.props.displayLegend,
                                                 position:this.props.legendPosition
                                                }
                                            }}
                                        />                                         
                                        }
                                         </Paper>
                                    </Col>
                                    <Col md="6" >
                                    <Paper> 
                                    {Object.keys(this.state.chartPropostaCanceladas).length &&
                                            <HorizontalBar
                                            data={this.state.chartPropostaCanceladas}
                                            options={{
                                                indexAxis: 'y',
                                                title:{
                                                display: true,
                                                text:'Propostas canceladas',
                                                fontSize:14
                                                },
                                                scales: {
                                                xAxes: [{
                                                    ticks: {
                                                    beginAtZero:true,
                                                    //max: this.props.max,
                                                    min: 0,
                                                    stepSize: 5
                                                    }
                                                }]
                                                },            
                                                legend:{
                                                 display:this.props.displayLegend,
                                                  position:this.props.legendPosition
                                                }
                                            }}
                                        />                                         
                                        }
                                         </Paper>
                                    </Col>      
                                                                
         
                                </Row>   
                                <Row>
                                    <Col>
                                    <br></br>
                                    </Col>
                                </Row>  
                                <Row>
                                    <Col>
                                    <paper>
                                       {/* colocar aqui o gráfico do google chart */}
                                    </paper>
                                    </Col>
                                </Row>  
                       
                         </Container>
                    </Container>

                  
        </div>
        );

    }

}


export default Select;

/**
 * <Barr chartData={this.state.chartData} location=" - sdf " legendPosition="bottom" ref={(reference) => this.chartReference = reference } />  
 */



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Dashboard/DashboardAdministrador.js
 **/